export enum MoocActionTypes {
    //导航
    ACTION_MOOC_SETNAV = 'ACTION_MOOC_SETNAV', 
   
  
  }